const _isProxy = window.location.hostname.includes('idm.oclc.org') || window.location.hostname.includes('ezproxy');
// Cuando se accede vía proxy OCLC (HTTPS), usar URL relativa para evitar mixed content HTTP/HTTPS
const _rawBackend = process.env.REACT_APP_BACKEND_URL || '';
export const backendURL = _isProxy ? _rawBackend.replace(/^https?:\/\/[^/]+/, '') : _rawBackend;
export const IS_PUBLIC = !_isProxy;
export const PROXY_URL = process.env.REACT_APP_PROXY_URL || '#';
